export const SWITCH_MODES = {
  false: "Off",
  true: "On",
};
